// src/components/Navbar.js
import { useState, useContext } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
  Divider,
  Tooltip,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { Link } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import ThemeModeContext from '../contexts/ThemeModeContext';

export default function Navbar() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { user, logout } = useContext(AuthContext);
  const { mode, toggleMode } = useContext(ThemeModeContext);

  const menuItems = [
    { text: 'Pneus', path: '/tires', roles: ['ADMIN', 'EMPLOYEE'] },
    { text: 'Stock', path: '/stock', roles: ['ADMIN', 'EMPLOYEE'] },
    { text: 'Partenaires', path: '/partners', roles: ['ADMIN'] },
    { text: 'Fournisseurs', path: '/suppliers', roles: ['ADMIN'] },
    { text: 'Caisse', path: '/cash', roles: ['ADMIN'] },
    { text: 'Finance', path: '/finance', roles: ['ADMIN'] },
    { text: 'Depenses', path: '/expenses', roles: ['ADMIN'] },
    { text: 'Employes', path: '/users', roles: ['ADMIN'] },
    { text: 'Mon salaire', path: '/payroll', roles: ['ADMIN', 'EMPLOYEE'] },
    { text: 'Tableau de bord', path: '/dashboard', roles: ['ADMIN', 'EMPLOYEE'] },
  ].filter(item => user && item.roles.includes(user.role));

  return (
    <>
    <AppBar
      position="static"
      elevation={0}
      sx={{
        background: 'var(--navbar-bg)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid var(--border-subtle)',
      }}
    >
       <Toolbar>
  {/* Logo + Titel */}
        <Box
          component={Link}
          to="/"
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexGrow: 1,
            textDecoration: 'none',
            gap: { xs: 1, sm: 1.5 },
          }}
        >
          <Box
            component="img"
            src="/logo.png"
            alt="SOSP Logo"
            sx={{
              height: { xs: 42, sm: 54 },
              width: { xs: 96, sm: 130 },
              objectFit: 'cover',
              objectPosition: 'center',
              mr: { xs: 0.5, sm: 1.5 },
              ml: { xs: -0.5, sm: 0 },
              filter: 'drop-shadow(0 6px 12px rgba(0,0,0,0.35))',
            }}
          />

          <Typography
            sx={{
              color: 'var(--text-primary)',
              fontWeight: 800,
              letterSpacing: 1,
              fontSize: {
                xs: '0.9rem',
                sm: '1.1rem',
                md: '1.25rem',
              },
              whiteSpace: 'nowrap',
            }}
          >
            Gestion des pneus
          </Typography>
        </Box>

  {/* Theme toggle + Burger Menue */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Tooltip title={mode === 'dark' ? 'Hellmodus' : 'Dunkelmodus'}>
            <IconButton
              aria-label="Theme umschalten"
              onClick={toggleMode}
              sx={{
                color: 'var(--text-primary)',
                backgroundColor: 'var(--icon-button-bg)',
                border: '1px solid var(--icon-button-border)',
                '&:hover': {
                  backgroundColor: 'var(--icon-button-hover-bg)',
                },
              }}
            >
              {mode === 'dark' ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
            </IconButton>
          </Tooltip>
          <IconButton
            edge="end"
            onClick={() => setDrawerOpen(true)}
            sx={{
              color: 'var(--text-primary)',
              backgroundColor: 'var(--icon-button-bg)',
              border: '1px solid var(--icon-button-border)',
              '&:hover': {
                backgroundColor: 'var(--icon-button-hover-bg)',
              },
            }}
          >
            <MenuIcon fontSize="medium" />
          </IconButton>
        </Box>
</Toolbar>

      </AppBar>

      {/* Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box
          sx={{
            width: 260,
            height: '100%',
            background: 'var(--drawer-bg)',
            color: 'var(--text-primary)',
          }}
          role="presentation"
          onClick={() => setDrawerOpen(false)}
        >
          <List sx={{ py: 1 }}>
            {menuItems.map((item) => (
              <ListItem key={item.text} disablePadding>
                <ListItemButton
                  component={Link}
                  to={item.path}
                  sx={{
                    px: 3,
                    py: 1.4,
                    '&:hover': { backgroundColor: 'var(--row-hover-bg)' },
                  }}
                >
                  <ListItemText
                    primary={item.text}
                    primaryTypographyProps={{ fontWeight: 700, letterSpacing: 0.3 }}
                  />
                </ListItemButton>
              </ListItem>
            ))}

            <Divider sx={{ my: 1, opacity: 0.2 }} />

            <ListItem disablePadding>
              <ListItemButton
                onClick={logout}
                sx={{
                  px: 3,
                  py: 1.4,
                  '&:hover': { backgroundColor: 'rgba(239,68,68,0.15)' },
                }}
              >
                <ListItemText
                  primary="Deconnexion"
                  primaryTypographyProps={{ fontWeight: 700, letterSpacing: 0.3 }}
                />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </>
  );
}


